module.exports = __webpack_public_path__ + "static/img/sy-approval.38932ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/sy-approval.svg
// module id = fhs8
// module chunks = 25